// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notification-list-container {
  overflow: hidden;
}
.notification-list-container .notification-main {
  width: 100%;
  display: flex;
  overflow: hidden;
}
.notification-list-container .notification-center {
  width: 100%;
  background: #ffffff;
  overflow-y: auto;
  overflow-x: hidden;
  height: calc(100vh - 66px);
  scrollbar-width: none;
}
.notification-list-container .notification-center::-webkit-scrollbar {
  width: 0px;
}
.notification-list-container .notification-center::-webkit-scrollbar-thumb {
  background: transparent;
}
.notification-list-container .header-navigation {
  background: #c0c8da;
  height: 2.4rem;
  border: 1px solid #c0c8da;
  width: 99.5%;
}
.notification-list-container .header-navigation .notification-list-text {
  font-family: "Nunito";
  font-size: 12px;
  font-weight: 500;
  color: #2D2D2D;
  padding: 0.5rem;
}
.notification-list-container .notification-section .search-excel-button {
  display: flex;
  justify-content: space-between;
  width: 98%;
  margin: 20px auto;
}
.notification-list-container .notification-section .search-excel-button .search-notification-input,
.notification-list-container .notification-section .search-excel-button .excel-create-btn {
  width: 50%;
}
.notification-list-container .notification-section .search-excel-button .search-notification-input {
  display: flex;
  align-items: center;
  gap: 15px;
}
.notification-list-container .notification-section .search-excel-button .search-notification-input .search-notification {
  display: flex;
  align-items: center;
  gap: 15px;
  width: 100%;
}
.notification-list-container .notification-section .search-excel-button .excel-create-btn {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
}
.notification-list-container .notification-section .search-excel-button .excel-create-btn .create-notification-button {
  background-color: #0c3688;
  color: white;
  border-radius: 5px;
  padding: 0px 10px;
}
.notification-list-container .notification-section .select-criteria,
.notification-list-container .notification-section .input-criteria,
.notification-list-container .notification-section .date-input,
.notification-list-container .notification-section .search-button,
.notification-list-container .notification-section .excel-button,
.notification-list-container .notification-section .create-notification-button {
  height: 40px;
  outline: none;
}
.notification-list-container .notification-section .select-criteria,
.notification-list-container .notification-section .input-criteria,
.notification-list-container .notification-section .date-input {
  border: 1px solid #A3AEC4;
  padding: 0px 10px;
}
.notification-list-container .notification-section .search-button {
  background-color: #0c3688;
  color: white;
  border-radius: 5px;
  width: 80px;
}
.notification-list-container .notification-section .search-button:disabled {
  background: linear-gradient(277.62deg, #2b3955 10%, #6994ec 84.88%);
}
.notification-list-container .notification-section .create-bulk-excel {
  display: flex;
  justify-content: flex-end;
  width: 98%;
  margin: 20px auto;
}
.notification-list-container .notification-section .create-bulk-excel .create-notification-button {
  background-color: #0c3688;
  color: white;
  border-radius: 5px;
  padding: 0px 10px;
}
.notification-list-container .notification-section .notification-table {
  width: 98%;
  margin: auto;
}
.notification-list-container .notification-section .notification-table table {
  width: 100%;
  border-collapse: collapse;
}
.notification-list-container .notification-section .notification-table table th,
.notification-list-container .notification-section .notification-table table td {
  padding: 12px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}
.notification-list-container .notification-section .notification-table table tr {
  border-bottom: 1px solid #ddd;
}
.notification-list-container .notification-section .notification-table table .user-name-column {
  padding-left: 20px;
}
.notification-list-container .notification-section .notification-table table th {
  background-color: #f4f4f4;
  font-size: 16px;
}
.notification-list-container .notification-section .notification-table .pagination-comp {
  margin-top: 2rem;
  margin-bottom: 3rem;
}
.notification-list-container .notification-section .notification-table .action-btn {
  display: flex;
  gap: 15px;
}
.notification-list-container .notification-section .notification-table .edit-btn {
  background: #47B900;
  border: none;
  cursor: pointer;
  color: white;
  font-size: 16px;
  padding: 8px 7px;
  border-radius: 4px;
  width: 35px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.notification-list-container .notification-section .notification-table .delete-btn {
  background-color: #DA0000;
  border: none;
  cursor: pointer;
  color: white;
  font-size: 16px;
  padding: 8px 7px;
  border-radius: 4px;
  width: 35px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
}

@media (max-width: 768px) {
  .notification-main {
    flex-direction: column;
  }
  .notification-main .notification-center {
    width: 100%;
  }
  .notification-main .search-excel-button {
    flex-direction: column;
    gap: 20px;
  }
  .notification-main .search-excel-button .search-notification-input {
    width: 100% !important;
  }
  .notification-main .search-excel-button .excel-create-btn {
    width: 100% !important;
    justify-content: flex-start !important;
  }
  .notification-main .search-excel-button .excel-create-btn .noti-excel {
    font-size: 14px;
  }
  .notification-main .search-excel-button .excel-create-btn .create-notification-button {
    font-size: 14px;
  }
  .notification-main .search-excel-button .excel-create-btn .download-noti-excel {
    width: 50%;
  }
  .notification-main .create-bulk-excel {
    justify-content: flex-start !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/NotificationList/NotificationList.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;AACJ;AACI;EACI,WAAA;EACA,aAAA;EACA,gBAAA;AACR;AAEI;EACI,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,0BAAA;EAUA,qBAAA;AATR;AACQ;EACE,UAAA;AACV;AAEQ;EACE,uBAAA;AAAV;AAMI;EACI,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,YAAA;AAJR;AAMQ;EACI,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AAJZ;AASQ;EACI,aAAA;EACA,8BAAA;EACA,UAAA;EACA,iBAAA;AAPZ;AASY;;EAEI,UAAA;AAPhB;AAUY;EACI,aAAA;EACA,mBAAA;EACA,SAAA;AARhB;AAUgB;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;AARpB;AAYY;EACI,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,SAAA;AAVhB;AAYgB;EACI,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AAVpB;AAeQ;;;;;;EAMI,YAAA;EACA,aAAA;AAbZ;AAgBQ;;;EAGI,yBAAA;EACA,iBAAA;AAdZ;AAiBQ;EACI,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;AAfZ;AAiBY;EACI,mEAAA;AAfhB;AAoBQ;EACI,aAAA;EACA,yBAAA;EACA,UAAA;EACA,iBAAA;AAlBZ;AAoBY;EACI,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AAlBhB;AAsBQ;EACI,UAAA;EACA,YAAA;AApBZ;AAsBY;EACI,WAAA;EACA,yBAAA;AApBhB;AAsBgB;;EAEI,aAAA;EACA,gBAAA;EACA,6BAAA;AApBpB;AAsBgB;EACI,6BAAA;AApBpB;AAuBgB;EACI,kBAAA;AArBpB;AAwBgB;EACI,yBAAA;EACA,eAAA;AAtBpB;AA0BY;EACI,gBAAA;EACA,mBAAA;AAxBhB;AA2BY;EACI,aAAA;EACA,SAAA;AAzBhB;AA4BY;EACI,mBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA1BhB;AA6BY;EACI,yBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA3BhB;;AAmCA;EACI;IACI,sBAAA;EAhCN;EAkCM;IACI,WAAA;EAhCV;EAmCM;IACI,sBAAA;IACA,SAAA;EAjCV;EAmCU;IACI,sBAAA;EAjCd;EAoCU;IACI,sBAAA;IACA,sCAAA;EAlCd;EAoCc;IACI,eAAA;EAlClB;EAqCc;IACI,eAAA;EAnClB;EAsCc;IACI,UAAA;EApClB;EA0CM;IACI,sCAAA;EAxCV;AACF","sourcesContent":[".notification-list-container {\n    overflow: hidden;\n\n    .notification-main {\n        width: 100%;\n        display: flex;\n        overflow: hidden;\n    }\n\n    .notification-center {\n        width: 100%;\n        background: #ffffff;\n        overflow-y: auto;\n        overflow-x: hidden;\n        height: calc(100vh - 66px);\n    \n        &::-webkit-scrollbar {\n          width: 0px;\n        }\n    \n        &::-webkit-scrollbar-thumb {\n          background: transparent;\n        }\n    \n        scrollbar-width: none;\n    }\n\n    .header-navigation {\n        background: #c0c8da;\n        height: 2.4rem;\n        border: 1px solid #c0c8da;\n        width: 99.5%;\n\n        .notification-list-text {\n            font-family: \"Nunito\";\n            font-size: 12px;\n            font-weight: 500;\n            color: #2D2D2D;\n            padding: 0.5rem;\n        }\n    }\n\n    .notification-section {\n        .search-excel-button {\n            display: flex;\n            justify-content: space-between;\n            width: 98%;\n            margin: 20px auto;\n\n            .search-notification-input,\n            .excel-create-btn {\n                width: 50%;\n            }\n\n            .search-notification-input {\n                display: flex;\n                align-items: center;\n                gap: 15px;\n\n                .search-notification {\n                    display: flex;\n                    align-items: center;\n                    gap: 15px;\n                    width: 100%;\n                }\n            }\n\n            .excel-create-btn {\n                display: flex;\n                justify-content: flex-end;\n                align-items: center;\n                gap: 10px;\n\n                .create-notification-button {\n                    background-color: #0c3688;\n                    color: white;\n                    border-radius: 5px;\n                    padding: 0px 10px;\n                }\n            }\n        }\n\n        .select-criteria,\n        .input-criteria,\n        .date-input,\n        .search-button,\n        .excel-button,\n        .create-notification-button {\n            height: 40px;\n            outline: none;\n        }\n\n        .select-criteria,\n        .input-criteria,\n        .date-input {\n            border: 1px solid #A3AEC4;\n            padding: 0px 10px;\n        }\n\n        .search-button {\n            background-color: #0c3688;\n            color: white;\n            border-radius: 5px;\n            width: 80px;\n\n            &:disabled{\n                background: linear-gradient(277.62deg, #2b3955 10%, #6994ec 84.88%);\n            }\n            \n        }\n\n        .create-bulk-excel {\n            display: flex;\n            justify-content: flex-end;\n            width: 98%;\n            margin: 20px auto;\n\n            .create-notification-button {\n                background-color: #0c3688;\n                color: white;\n                border-radius: 5px;\n                padding: 0px 10px;\n            }\n        }  \n        \n        .notification-table{\n            width: 98%;\n            margin: auto;\n\n            table{\n                width: 100%;\n                border-collapse: collapse;\n    \n                th,\n                td {\n                    padding: 12px;\n                    text-align: left;\n                    border-bottom: 1px solid #ddd;\n                }\n                tr{\n                    border-bottom: 1px solid #ddd;\n                }\n    \n                .user-name-column{\n                    padding-left: 20px;\n                }\n    \n                th {\n                    background-color: #f4f4f4;\n                    font-size: 16px;\n                }\n            }\n    \n            .pagination-comp {\n                margin-top: 2rem;\n                margin-bottom: 3rem;\n            }\n    \n            .action-btn{\n                display: flex;\n                gap: 15px;\n            }\n    \n            .edit-btn {\n                background: #47B900;\n                border: none;\n                cursor: pointer;\n                color: white;\n                font-size: 16px;\n                padding: 8px 7px;\n                border-radius: 4px;\n                width: 35px;\n                height: 35px;\n                display: flex;\n                align-items: center;\n                justify-content: center;\n            }\n    \n            .delete-btn {\n                background-color: #DA0000;\n                border: none;\n                cursor: pointer;\n                color: white;\n                font-size: 16px;\n                padding: 8px 7px;\n                border-radius: 4px;\n                width: 35px;\n                height: 35px;\n                display: flex;\n                align-items: center;\n                justify-content: center;\n            }\n        }\n\n\n    }\n}\n\n@media (max-width: 768px) {\n    .notification-main {\n        flex-direction: column;\n\n        .notification-center{\n            width: 100%;\n        }\n\n        .search-excel-button{\n            flex-direction: column;\n            gap: 20px;\n\n            .search-notification-input{\n                width: 100% !important;\n            }\n\n            .excel-create-btn{\n                width: 100% !important;\n                justify-content: flex-start !important;\n\n                .noti-excel{\n                    font-size: 14px;\n                }\n\n                .create-notification-button{\n                    font-size: 14px;\n                }\n\n                .download-noti-excel{\n                    width: 50%;\n                }\n            }\n\n            \n        }\n        .create-bulk-excel{\n            justify-content: flex-start !important;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
